import React from "react";
import clsx from "clsx";

const variants = {
  primary: "bg-primary-500 text-white hover:bg-primary-600 focus:ring-primary-500",
  secondary: "bg-dark-200 text-dark-700 hover:bg-dark-300 focus:ring-dark-500 dark:bg-dark-700 dark:text-dark-200 dark:hover:bg-dark-600",
  ghost: "bg-transparent text-dark-500 hover:bg-dark-100 hover:text-dark-700 focus:ring-dark-500 dark:text-dark-400 dark:hover:bg-dark-800 dark:hover:text-dark-200",
  danger: "bg-transparent text-danger-500 hover:bg-danger-50 focus:ring-danger-500 dark:hover:bg-danger-900/20",
  success: "bg-transparent text-success-500 hover:bg-success-50 focus:ring-success-500 dark:hover:bg-success-900/20",
};

const sizes = {
  xs: "p-1",
  sm: "p-1.5",
  small: "p-1.5",
  md: "p-2",
  medium: "p-2",
  lg: "p-2.5",
  large: "p-2.5",
  xl: "p-3",
};

const iconSizes = {
  xs: "w-3 h-3",
  sm: "w-4 h-4",
  small: "w-4 h-4",
  md: "w-5 h-5",
  medium: "w-5 h-5",
  lg: "w-6 h-6",
  large: "w-6 h-6",
  xl: "w-7 h-7",
};

const IconButton = React.forwardRef(({
  children,
  icon,
  variant,
  color,
  size = "md",
  disabled = false,
  loading = false,
  rounded = true,
  className = "",
  title,
  ...props
}, ref) => {
  // Support both variant and color props (color is an alias for variant)
  const resolvedVariant = variant || color || "ghost";
  return (
    <button
      ref={ref}
      type="button"
      disabled={disabled || loading}
      title={title}
      aria-label={title}
      className={clsx(
        "inline-flex items-center justify-center",
        "transition-all duration-200",
        "focus:outline-none focus:ring-2 focus:ring-offset-2 dark:focus:ring-offset-dark-900",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        rounded ? "rounded-full" : "rounded-lg",
        variants[resolvedVariant],
        sizes[size],
        className
      )}
      {...props}
    >
      {loading ? (
        <svg
          className={clsx("animate-spin", iconSizes[size])}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      ) : (
        <span className={iconSizes[size]}>{icon || children}</span>
      )}
    </button>
  );
});

IconButton.displayName = "IconButton";

export default IconButton;
